import React from 'react';
import { useMaquetesTheme } from '../context/MaquetesThemeContext';
import { OrcamentoDialog, useOrcamentoFeedback } from './OrcamentoUI';

// Existing dialogs retain their normal appearance outside the liquid theme.
export function LiquidDialog({ children, onClose, onClick, ...props }) {
    const { theme, active } = useMaquetesTheme();
    if (!active || theme !== 'liquido') return <div {...props} onClick={onClick}>{children}</div>;
    return <OrcamentoDialog {...props} data-liquid-dialog="true" onClose={onClose}>
        {React.Children.map(children, child => React.isValidElement(child) && typeof child.type === 'string'
            ? React.cloneElement(child, { className: `${child.props.className || ''} liquid-dialog-card` }) : child)}
    </OrcamentoDialog>;
}
const nativeFeedback = {
    notify: message => Promise.resolve(window.alert(message)),
    confirm: message => Promise.resolve(window.confirm(message)),
};
export function useLiquidFeedback() { return useOrcamentoFeedback() || nativeFeedback; }